import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useWebsocket } from '../../hooks/useWebsocket'
import PassengerList from '../../modules/passengers/PassengerList'
import { addSubscription, removeSubscription } from '../../state/websocket.slice'
import { getWebsocketChannel } from '../../utils/websocket'

function PassengersPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { subscribeToChannel, unsubscribeFromChannel } = useWebsocket()

  const handleViewPassenger = (passenger) => {
    navigate(`/passengers/${passenger._id}`)
  }

  const handleEditPassenger = (passenger) => {
    console.log('Editing passenger:', passenger)
    // TODO: Implement edit passenger functionality
  }

  const handleDeletePassenger = (passenger) => {
    console.log('Deleting passenger:', passenger)
    // TODO: Implement delete passenger functionality
  }

  useEffect(() => {
    const channelName = getWebsocketChannel().passengerList

    if (channelName) {
      subscribeToChannel(channelName)
      dispatch(addSubscription(channelName))
    }

    return () => {
      if (channelName) {
        unsubscribeFromChannel(channelName)
        dispatch(removeSubscription(channelName))
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-6 text-left">
        <h1 className="text-2xl font-bold text-neutral-900 dark:text-white mb-2">
          Passenger Management
        </h1>
        <p className="text-neutral-600 dark:text-neutral-400">
          Manage passenger information, preferences, and loyalty programs
        </p>
      </div>

      <PassengerList
        onViewPassenger={handleViewPassenger}
        onEditPassenger={handleEditPassenger}
        onDeletePassenger={handleDeletePassenger}
      />
    </div>
  )
}

export default PassengersPage
